import React from "react";
import { motion } from "framer-motion";

export default function ModernStatCard({
  title,
  value,
  icon: Icon,
  subtitle,
  trend,
  trendValue,
  variant = "default",
  delay = 0,
}) {
  const variants = {
    default: {
      bg: "#ffffff",
      iconBg: "#f1f5f9",
      iconColor: "#64748b",
      border: "#e2e8f0",
    },
    primary: {
      bg: "#ffffff",
      iconBg: "#eff6ff",
      iconColor: "#3b82f6",
      border: "#dbeafe",
    },
    success: {
      bg: "#ffffff",
      iconBg: "#f0fdf4",
      iconColor: "#22c55e",
      border: "#dcfce7",
    },
    warning: {
      bg: "#ffffff",
      iconBg: "#fef3c7",
      iconColor: "#f59e0b",
      border: "#fde68a",
    },
    danger: {
      bg: "#ffffff",
      iconBg: "#fee2e2",
      iconColor: "#ef4444",
      border: "#fecaca",
    },
  };

  const colors = variants[variant] || variants.default;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay, ease: [0.4, 0, 0.2, 1] }}
      whileHover={{
        scale: 1.02,
        boxShadow: "0 6px 12px rgba(0,0,0,0.08)",
        backgroundColor: "#f9fafb",
        transition: { duration: 0.2 },
      }}
      style={{
        background: colors.bg,
        border: `1px solid ${colors.border}`,
        borderRadius: "12px",
        padding: "20px",
        cursor: "default",
        boxShadow:
          "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)",
        transition: "all 0.2s ease",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          justifyContent: "space-between",
        }}
      >
        <div style={{ flex: 1 }}>
          <p
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#64748b",
              margin: 0,
              marginBottom: "8px",
            }}
          >
            {title}
          </p>
          <h3
            style={{
              fontSize: "30px",
              fontWeight: "700",
              color: "#0f172a",
              margin: 0,
              marginBottom: "4px",
              lineHeight: "1",
            }}
          >
            {value}
          </h3>
          {subtitle && (
            <p
              style={{
                fontSize: "13px",
                color: "#94a3b8",
                margin: 0,
              }}
            >
              {subtitle}
            </p>
          )}
        </div>

        <div
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "10px",
            background: colors.iconBg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          {Icon && <Icon size={24} color={colors.iconColor} strokeWidth={2} />}
        </div>
      </div>

      {trend && (
        <div
          style={{
            marginTop: "12px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <span
            style={{
              fontSize: "12px",
              fontWeight: "600",
              color: trend === "up" ? "#22c55e" : "#ef4444",
            }}
          >
            {trend === "up" ? "↑" : "↓"} {trendValue}
          </span>
          <span style={{ fontSize: "12px", color: "#94a3b8" }}>
            vs last month
          </span>
        </div>
      )}
    </motion.div>
  );
}
